module.exports = __webpack_public_path__ + "img/top.2b4174aa.png";